import { AccessLevel } from "@/api/williams/users";
import { usePermissions } from "../hooks";

const ACCESS_LEVEL_DISPLAY_NAMES = {
  [AccessLevel.Administrator]: "Administrator",
  [AccessLevel.AIWeldingSME]: "AI Welding SME",
  [AccessLevel.WeldingSpecialist]: "Welding Specialist",
  [AccessLevel.WeldingInspector]: "Welding Inspector",
  [AccessLevel.GeneralUser]: "General User",
};

export function WilliamsUserAccessLevel() {
  const { data, isSuccess } = usePermissions();

  if (isSuccess) {
    return <>{ACCESS_LEVEL_DISPLAY_NAMES[data.accessLevel]}</>;
  } else {
    return null;
  }
}
